import { useContext } from 'react';
import { SelectedRowsContext } from '../../context/SelectedRowsContext/SelectedRowsContext';

export const useSelectedRowsContext = () => {
  const context = useContext(SelectedRowsContext);

  if (context.isProvided === false) {
    throw new Error(
      'useSelectedRowsContext must be used within a SelectedRowsContextProvider'
    );
  }

  return context;
};
